export enum WaterFlowErrorTypeId {
  PointingAtLand = 1,
  PointingAtLandDiagonal = 2,
}
